export class GenericDetailedError extends Error {
  details: string;

  constructor(message: string, details: string) {
    super(message); // 'Error' breaks prototype chain here
    Object.setPrototypeOf(this, new.target.prototype); // restore prototype chain
    this.details = details;
  }
}
